import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BusinessPartnerGroupBusinessPartnerModel from '../../../models/BusinessPartnerGroupBusinessPartnerModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddBusinessPartnerPopup from '../Popups/BusinessPartner_popup_AddBusinesPartnerGroup';

const BusinessPartner_tab_BusinessPartnerGroups: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<BusinessPartnerGroupBusinessPartnerModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<BusinessPartnerGroupBusinessPartnerModel[]>('api/v1/BusinessPartnerGroupBusinessPartners/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/BusinessPartnerGroupBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerGroupId', visible: false },
        { title: 'Name', dataProp: 'businessPartnerGroup', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerBusinessPartnerGroups'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Business-partner group'
                navigateUrl='/plm/BusinessPartners/BusinessPartnerGroup/'
            />
            {showPopup && <AddBusinessPartnerPopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default BusinessPartner_tab_BusinessPartnerGroups;